import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi) // Load translations from a backend
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass the i18n instance to react-i18next
  .init({
    supportedLngs: ['en', 'fr'],
    fallbackLng: 'fr',
    lng: 'fr', // Default language
    debug: false,
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    backend: {
      // Préfixe de montage de l'app (BASE_URL: "/jeu-alignement/" dans le méga-
      // conteneur GAO, "/" en dev/multi). Sans lui, i18next demande
      // /locales/... à la racine du conteneur → 404 → clés brutes affichées
      // (ex: "Navigation.buyer_menu.bienvenue" au lieu de "Bienvenue").
      loadPath: `${import.meta.env.BASE_URL || '/'}locales/{{lng}}/{{ns}}.json`,
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
